module.exports = __webpack_public_path__ + "f7548c4c60349faa784c2fdcdc6ac0e7.jpg";